import { useSelector, useDispatch } from 'react-redux';
import PromptsWrapper from './Prompts/PromptsWrapper';
import { QuestionnairePage } from './Questionnaire/Questionnaire.page';
import LLMs from './LLM/LLMs';
import { KnowledgeBasePage } from './KnowledgeBase/ListKnowledgeBase';
import { KnowledgeBaseOverridesPage } from './KnowledgeBaseOverrides/ListKnowledgeBaseOverrides';
import { PromptScreensPage } from './PromptScreens/PromptScreens.page';
import { SegmentedTabs } from 'src/modules/ambient_solo/components/PastEncounter/SegmentedTabs';
import OrganizationFilter from '../OrganizationFilter';
import { setActiveTabAction } from 'src/modules/SuperAdmin/store/actions/superadmin.action';

const AiComponents = () => {
  const dispatch = useDispatch();
  const { activeTab, activeSubTab } = useSelector(
    (state) => state?.superadminState || {}
  );

  const options = [
    { label: 'Prompts', value: 'Prompts' },
    { label: 'Prompt Screens', value: 'Prompt Screens' },
    { label: 'Questionnaire', value: 'Questionnaire' },
    { label: 'LLMs', value: 'LLMs' },
    { label: 'Knowledge Base', value: 'Knowledge Base' },
    { label: 'Knowledge Base Overrides', value: 'Knowledge Base Overrides' },
  ];

  const globalTabs = ['Questionnaire', 'Knowledge Base', 'Prompt Screens'];
  const globalSubTabs = {
    Prompts: {
      globalSubTabs: ['Specialties', 'Magicflow', 'Plan'],
    },
  };

  // Determine if OrganizationFilter should be disabled
  const isOrganizationFilterDisabled = () => {
    // Global scope tabs (organization filter should be disabled)

    if (globalTabs.includes(activeTab)) {
      return true;
    }

    // For tabs with sub-tabs, check if the current sub-tab is global
    if (globalSubTabs[activeTab]) {
      return globalSubTabs[activeTab].globalSubTabs.includes(activeSubTab);
    }

    return false;
  };

  const handleTabChange = (tab) => {
    dispatch(setActiveTabAction(tab));
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'Prompts':
        return <PromptsWrapper />;
      case 'Questionnaire':
        return <QuestionnairePage />;
      case 'LLMs':
        return <LLMs />;
      case 'Knowledge Base':
        return <KnowledgeBasePage />;
      case 'Knowledge Base Overrides':
        return <KnowledgeBaseOverridesPage />;
      case 'Prompt Screens':
        return <PromptScreensPage />;
      default:
        return <PromptsWrapper />;
    }
  };

  return (
    <div className="page-wrapper">
      <div className="flex justify-between items-end">
        <div className="flex justify-start">
          <SegmentedTabs
            options={options}
            activeTab={activeTab}
            setActiveTab={handleTabChange}
            disabled={false}
          />
        </div>
        <div className="flex items-center gap-2">
          <label className="text-md text-gray-600 font-medium">
            Select organization:
          </label>
          <OrganizationFilter disabled={isOrganizationFilterDisabled()} />
        </div>
      </div>
      <div style={{ marginTop: '16px' }}>{renderContent()}</div>
    </div>
  );
};

export default AiComponents;
